<div class="modal-container">
  <div class="modal-header border-0">
    <h1 class="modal-title text-primary-color">
      Import
    </h1>
  </div> 
  <div class="modal-body flex-grow-1 custom-scroll">
    <app-import-documents></app-import-documents>
  </div>
</div>